import { TicketRepository } from '../repositories/TicketRepository'

export function ListAreaByIdCase(ticketRepository: TicketRepository) {
  return async function ({ areaId }: { areaId: string }) {
    return await ticketRepository.listAreaById({ areaId })
  }
}
